// extracted by mini-css-extract-plugin
module.exports = {"content":"CarouselContent_content__3eFb6"};